import React from 'react';
import Reflux from 'reflux';
import UserStore from 'stores/userStore';
import Alerts from 'components/alerts';

class App extends Reflux.Component {
    constructor(props) {
        super(props);

        this.store = UserStore;
    }

    setupAppLinks() {
        const appLinks = document.getElementsByClassName('app-link');
        const navbarToggle = $('.navbar-toggle');

        Array.from(appLinks).forEach(appLink => {
            appLink.addEventListener('click', (e) => {
                e.preventDefault();

                if (navbarToggle.is(':visible')) {
                    navbarToggle.trigger('click');
                }

                this.context.router.push(e.target.pathname || '/');
            });
        });
    }

    /* eslint class-methods-use-this: 0 */
    setupNavigation() {
        const navbarToggle = $('.navbar-toggle');

        $('#navbar').on('click', '.nav a', () => {
            if (navbarToggle.is(':visible')) {
                navbarToggle.trigger('click');
            }
        });

        $('.navbar-link').on('click', () => {
            if (navbarToggle.is(':visible')) {
                navbarToggle.trigger('click');
            }
        });
    }

    componentWillMount() {
        this.setupAppLinks();
        this.setupNavigation();

        super.componentWillMount();
    }

    render() {
        return (
            <div>
                <Alerts className="alerts-container" />
                {this.props.children}
            </div>
        );
    }
}

App.contextTypes = {
    router: React.PropTypes.object,
};

export default App;



// WEBPACK FOOTER //
// ./app/assets/javascripts/views/app.jsx